module.exports = __webpack_public_path__ + "img/lt_corpus_free.e311c91a.png";